module.exports = __webpack_public_path__ + "static/media/cybersports.e77440a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cybersports.svg
// module id = 370
// module chunks = 7